module.exports = __webpack_public_path__ + "img/bg_math_03.c7618db7.jpg";